export default {
  "operator": "操作人",
  "operateDate": "操作日期",
  "informationConfirm": "信息确认",
  "animalModel": "动物模型",
  "group": "组",
  "export": "导出",
  "reportInfo": "报告信息",
  "additionalData": "额外信息",
  "source": "来源",
  "recentlyUsed": "最近使用",
  "percentage": "百分比",
  "needCages": "需要笼位",
  "nextWeekNum": "下周预计接收动物",
  "thisWeekNum": "本周预计接收动物",
  "company": "租户",
  "tenant": "租户",
  "costCenter": "成本中心",
  "dict": "字典",
  "input": "输入框",
  "date": "日期",
  "time": "时间",
  "num": "数量",
  "file": "文件",
  "delete": "删除",
  "log": "流程日志",
  "fileName": "文件名",
  "uploadTime": "上传时间",
  "uploadBy": "上传人",
  "downloadTime": "下载时间",
  "downloadBy": "下载人",
  "applyForModification": "申请修改",
  "close": "终止",
  "applyForClose": "申请终止",
  "createdDate": "创建日期",
  "createdBy": "创建人",
  "review": "审核",
  "plan": "计划",
  "createAmendment": "创建修订",
  "viewLogs": "查看日志",
  "template": "模板",
  "attachment": "附件",
  "basicInfo": "基本信息",
  "madeSomeChanges": "进行了修改",
  "AddReminder": '添加提醒',

  "common": {
    "ok": "确定",
    "isRequired": "必填",
    "type": "类型",
    "name": "名称",
    "numberRemaining": "剩余数量",
    "remaining": "剩余量",
    "used": "已使用",
    "total": "总量",
    "effectiveDuration": "有效期",
    "day": "天",
    "newWindow": "在新窗口中打开链接",
    "user": "用户",
    "id": "ID",
    "error": "错误",
    "site": "地点",
    "department": "部门",
    "comment": "备注",
    "submit": "提交",
    "location": "位置",
    "systemId": "系统ID",
    "project": "项目",
    "receive": "接收",
    "success": "成功",
    "approve": "批准",
    "reject": "拒绝",
    "cancel": "取消",
    "back": "返回",
    "active": "激活",
    "disabled": "禁止",
    "expired": "过期失效",
    "edit": "编辑",
    "update": "更新",
    "operate": "操作",
    "filter": "过滤",
    "clearFilter": "清空过滤",
    "search": "搜索",
    "searchBtn": "搜索",
    "upload": "上传",
    "download": "下载",
    exportRequest: '导出申请记录',
    "print": "打印",
    "list": "列表",
    "detail": "详情",
    "new": "新建",
    "save": "保存",
    "width": "宽度",
    "length": "长度",
    "request": "申请记录",
    "Register": "物品登记",
    "apply": "物品申请",
    "Attachment": "上传附件",
    "Denied": "已拒绝",
    "already": "已批准",
    "GenerateStudyRecords": "生成研究报告",
    "add": "添加",
    "unitPrice": "单价/元",
    "totalPrice": "总价/元",
    "AutomaticallyBySys": "提交后系统自动生成",
    "placeOfWork": "所在单位",
    "background": "背景",
    "age": "年龄",
    "order": "订购",
    "changeLog": '变更记录',
    "myList": '我的申请（含草稿）',
    "temporaryStorage": "暂存"
  },
  "AFMSystem": "动物饲养管理系统",
  "route": {
    "attachDownloadLog": "附件下载记录",
    "饲养管理": "饲养管理",
    "物料列表": "物料列表",
    "物料申请列表": "物料申请列表",
    '物料领用管理': '物料领用管理',
    "动物及环境监测": "动物及环境监测",
    "仪器设备及报修": "仪器设备及报修",
    "动物房信息汇总": "动物房信息汇总",
    "实验人员信息": "实验人员信息",
    "仪器管理及预约": "仪器管理及预约",
    "AFMSystem": "动物饲养管理系统",
    "poRequest": "PO & SAP",
    "poList": "PO",
    "po": "PO",
    "item": "其他信息管理",
    "studyTemplate": "Study Template",
    "mail": "邮件测试",
    "systemManagement": "系统管理",
    "usage": "使用记录",
    "study": "实验",
    "healthCheck": "健康检查",
    "cageCard": "笼卡",
    "cageCardManage": "打印模板管理",
    "protocol": "Protocol",
    "protocolList": "Protocol列表",
    "request": "动物申请",
    "requestList": "动物申请列表",
    "order": "订单",
    "orderList": "订单列表",
    "animalWelfare": "动物福利",
    "AnimalCare": "动物护理-兽医",
    "beastie": "动物健康检查",
    "CorpseDisRecord": "尸体处理记录",
    "environment": "环境",
    "FeedBedding": "饲料垫料",
    "repairs": "报修",
    "TemAndHumRecord": "温湿度记录",
    "toProtocol": "IACUC",
    "orderAndFeed": "动物订购及饲养登记",
    "feedingManagementAndCageStats": "饲养室管理/笼位统计",

    "feedingManagement": "饲养室管理",
    "feedingManagementDetail": "饲养室管理详情",

    "cageChargingStandard": "笼位-按课题组(PI)统计",
    "createFeedingRegister": "创建饲养登记",
    "addInspectionRecords": "新增巡检记录",
    'inspectionRecord': '巡检记录',

    "cageLocationPIStatistics": "笼位收费标准",
    "addCageLocationPIStatistics": "新增笼位收费标准",

    "orderRequestList": "订单申请",
    "biologicalPurificationList": "生物净化",
    "quarantineList": "隔离检疫",
    "selfCarryList": "自行购买",
    "animalInfoManageList": "动物信息管理",
    "subjectManagement": "学科管理",
    "subjectList": "学科列表",
    "subjectEdit": "学科创编",
    "knowledge": "知识点管理",
    "knowledgeList": "知识点列表",
    "knowledgeEdit": "知识点创编",
    "examPaper": "卷库管理",
    "examPaperList": "试卷列表",
    "ExamPaperCreate": "试卷创编",
    "examQuestion": "题库管理",
    "examQuestionList": "题目列表",
    "singleChoice": "单选题创编",
    "multipleChoice": "多选题创编",
    "trueFalse": "判断题创编",
    "gapFilling": "填空题创编",
    "shortAnswer": "简答题创编",
    "AnswerPage": "答卷管理",
    "AnswerJudgePageList": "批改列表",
    "AnswerCompletePageList": "试卷完成列表",
    "log": "日志中心",
    "logUserPage": "用户日志",
    "answerCenter": "答卷中心",
    "examRecords": "考试记录",
    "costsAndSettlement": "费用与结算",
    "costStatisticsList": "费用统计",
    "settlementStatisticsList": "结算统计",
    "rechargeAndRefundRecordList": "充值退款记录",
    "roomAndInstrument": "饲养间及仪器预约",
    "instrumentList": "仪器预约",
    "instrumentBookedList": "仪器预约记录",
    "roomList": "饲养间预约",
    "roomBookedList": "饲养间预约记录",
    "ItemCabinetBookedList": "物品柜预约",
    "externalServices": "外部服务",
    "offlineExamsAdmin": "线下培训管理",
    "offlineExams": "线下培训",
    "offlineExamsList": "线下培训报名",
    "examCenter": "伦理考试",
    "qualification": "资格准入",
    "applicationList": "我的准入申请",
    "applicationApply": "提交准入申请",
    "applicationDetail": "申请详情",
    "applicationAdmin": "准入申请管理",
    "applicationAdminDetail": "申请详情",
    "applicationExamDo": "开始考试",
    "applicationJudge": "批改答卷",
    "examApplicationList": "我的准入申请",
    "examApplicationApply": "提交准入申请",
    "examApplicationDetail": "申请详情",
    "examApplicationAdmin": "准入申请管理",
    "examApplicationAdminDetail": "申请详情",
    "onlineExams": "线上考试",
    "animalRequest": '动物代购'
  },

  "order": {
    "containerType": "运输箱类型",
    "labelOfContainer": "标签信息清晰",
    "statusOfContainer": "运输箱状态",
    "containerDisinfection": "运输箱消毒",
    "foodAvailable": "内有食物",
    "jellyGelAvailable": "内有果冻凝胶",
    "visualChecking": "动物状态外观检查",
    "checkingRecords": "随行记录检查",
    "checkBox": "动物接收和运输箱检查",
    "requestYear": "年份",
    "roomAssigned": "分配房间",
    "applicationForm": "申请表",
    "totalAmount": "总金额",
    "sameStudy": "同实验申请",
    "sendTo": "邮件发送",
    "orderInformation": "订单信息",
    "orderBy": "订单人",
    "orderId": "订单ID",
    "order": "订单",
    "delivery": "交付",
    "orderDate": "订单日期",
    "newRequest": "新的申请",
    "rejectRequest": "拒绝申请",
    "returnToSubmit": "返回至提交",
    "status": "订单状态",
    "placeOrder": "生成订单",
    "request": "申请",
    "requestHistory": "申请记录",
    "requestId": "申请编号",
    "requester": "申请人",
    "requestDate": "申请日期",
    "requestStatus": "申请状态",
    "expectedDeliveryDate": "预期接收日期",
    "requestInformation": "申请信息",
    "orderNumber": "订单数量",
    "requestNumber": "申请数量",
    "orderNo": "订单数量",
    "requestNo": "申请数量",
    "referDoc": "大小鼠周龄体重关系（20201021）",
    "arrival": "接收",
    "arrivalInformation": "接收信息",
    "arrivalBy": "接收人",
    "arrivalDate": "接收日期",
    "arrivalNo": "接收数量",
    "arrivalNumber": "接收数量",
    "healthCert": "健康证书",
    "guangdongCert": "广东省实验证明",
    "quarantineCert": "检疫合格证",
    "healthCertNo": "健康证书编号",
    "healthCertNumber": "健康证书编号",
    "arrivalRoom": "接收房间",
    "attachment": "附件（动物质量证书）",
    "completion": "完成度"
  },


  "protocol": {
    "submit": "提交审核",
    "close": "终止 Protocol",
    "newProtocol": "新建 Protocol",
    "newTemplate": "新建 Protocol 模板",
    "status": "Protocol 状态",
    "iacucNumber": "IACUC 编号",
    "protocolInformation": "Protocol 信息",
    "animalInformation": "动物信息",
    "protocolName": "Protocol 名字",
    "studyDirector": "Study Director",
    "studyMonitor": "Study Monitor",
    "contributionScientists": "Contribution Scientists",
    "effectiveDate": "生效日期",
    "effectiveList": "生效列表",
    "expireList": "未生效列表",
    "expireDate": "失效日期",
    "folderPath": "文件路径",
    "numberApproved": "IACUC可用数量",
    "numberRemaining": "IACUC剩余数量",
    "numberUsed": "IACUC使用量",
    "total": "总量",
    "percentage": "百分比",
    "iacucNo": "IACUC 编号",
    "sendToCommittee": "发送给委员会",
    "committeeMembers": "委员会成员",
    "committeeApproveComment": "复审备注",
    "committeeApprove": "复审通过",
    "primaryApproveComment": "初审备注",
    "primaryApprove": "初审通过",
    "return": "退回",
    "IACUCProtocol": "IACUC 编号",
    "IACUCProtocol2": "将于",
    "IACUCProtocol3": "到期，请尽快完成新的Protocol申请。"
  },

  "healthCheck": {
    "closeDate": "关闭日期",
    "closeBy": "关闭人",
    "euthanasiaMethod": "安乐死方法",
    "caseStatus": "检查状态",
    "caseResults": "检查结果",
    "caseNumber": "检查编号",
    "caseId": "检查Id",
    "close": "关闭",
    "healthCare": "兽医保健",
    "healthCheck": "健康检查",
    "checkType": "检查类型",
    "location": "Location",
    "clinicalSign": "Clinical Sign",
    "clinicalSignType": "Clinical Sign Type",
    "checkBy": "检查人",
    "checkDate": "检查日期",
    "checkNumber": "检查数量",
    "checkOption": "检测选项",
    "checkStage": "检测阶段",
    "checkItem": "QC项目",
    "samplingDate": "取样日期",
    "samplingSite": "采样位点",
    "sampleSize": "样本量",
    "values": "测定值（菌落数）",
    "criterion": "判定标准",
    "results": "结果判定",
    "materialName": "物料名称",
    "materialManufacturer": "厂家名称",
    "lot": "批号",
    "sampleNumber": "样本编号",
    "area": "面积",
    "lab": "三方实验室名称",
    "sampleType": "样本类型",
    "checkMode": "检测方式",
    "sampleName": "样品名称",
    "sterilizationDate": "灭菌日期",
    "opreation": "操作"
  },

  "study": {
    "studyNumber": "实验编号",
    "studyNo": "实验编号",
    "studyDirector": "实验负责人",
    "taskSegment": "任务段",
    "giftQuantity": "赠送数量",
    "diseaseType": "疾病类型",
    "projectType": "项目类型"
  },

  "animal": {
    "animalInformation": "动物信息",
    "vendor": "供应商",
    "strain": "品系",
    "species": "物种",
    "gender": "性别",
    "animalCode": "动物编号",
    "weight": "体重",
    "bodyWeight": "体重",
    "age": "周龄",
    "room": "房间",
    "gene": "基因型",
    "arrivalNo": "接收数量",
    "arrivalNumber": "接收数量",
    "arrivalAge": "接收周龄",
    "arrivalRoom": "接收房间",
    "rackNo": "架子编号"
  },

  "welfare": {
    "list": "福利列表",
    "Registration": "物品登记",
    "ItemApplyFor": "物品申请",
    "ApplicationRecord": "申请记录",
    "Out-of-stockReminders": "缺货提醒",
    "download": "下载"
  },


  "message": {
    "form": {
      "notFinish": "表单有必填项未填写",
      "requiredField": "该项为必填项",
      "maxField": "该项最大"
    },
    "enterToSearch": "输入内容后回车键搜索",
    "confirmRequestToSap": "PO剩余数量不足,是否继续?",
    "expectedDelivery": "预计接收日期为",
    "confirm": "操作前请确认",
    "roomNoAddInfo": "饲养间缺乏必要的信息，请联系管理员添加",
    "confirmRefreshRequest": "此操作会影响历史数据,是否继续?",
    "findDraftProtocol": "发现有未完成的protocol,确定要继续创建新的protocol吗",
    "sendEmailSuccess": "已经发送邮件",
    "studyOtherRequest": "请注意,实验还有其他的动物申请",
    "confirmReject": "确定要拒绝申请吗?",
    "rejectRequest": "已拒绝动物申请 ",
    "arrivalNumCheck": "接收数量必须大于0",
    "requestNumCheck": "申请数量必须大于0",
    "remainingNumNotEnough": "IACUC剩余数量为0,请更换IACUC或物种",
    "selectIACUCFirst": "请先选择IACUC",
    "requestRemainingCheck": "申请数量不能超过IACUC剩余数量",
    "closeProtocol": "确定要终止protocol吗?",
    "confirmDelete": "确定要删除吗",
    "confirmAction": " 操作前请确认",
    "confirmApprove": "确定要通过审批吗",
    "confirmReturnToSubmit": "确定要返回该请求至提交状态吗?",
    "roomIs": "房间号是 ",
    "deleteSuccess": "删除成功",
    "contextIsNull": "内容不能为空",
    "notSelect": "至少选择一条数据",
    "mustBeSubmit": "动物申请的状态必须是已提交",
    "selectReuquest": "没有选择申请信息",
    "printSuccess": "打印信息已经发送,请前往打印机查看",
    "updateSuccess": "更新成功",
    "confirmCancel": "确定要离开当前页面吗",
    "confirmReceive": "确定要进行动物接收吗",
    "selectEffectiveDateFirst": "先选择生效日期",
    "cancelOrder": "确定要取消订单吗",
    "cancelOrderSuccess": "订单已经取消",
    "success": "请求成功",
    "saveSuccess": "保存成功",
    "unsavedToLeave": "还有未保存的数据是否离开",
    "dateEarl": "交货日期不能早于申请日期",
    "roomAssigned": "请选择房间"
  },

  "filter": {
    "equal": "等于",
    "notEqual": "不等于",
    "in": "在列表",
    "like": "包含",
    "greaterThan": "大于",
    "lessThan": "小于"
  },

  "print": {
    "template": "打印模板",
    "templateName": "模板名字",
    "printNumber": "打印数量",
    // "quarantineNumber": "检疫号",
    // "project": "项目号",
    // "strain": "动物种属",
    // "studyDirector": "实验负责人",
    // "studyNumber": "实验编号",
    // "weight": "体重范围",
    // "RequestNumber": "数量"
  },

  "sap": {
    "contractNumber": "合同编号",
    "vendorCode": "供应商代码",
    "companyCode": "公司代码",
    "price": "价格 （元）",
    "costCenter": "成本中心",
    "staffCode": "员工编号",
    "wbs": "项目信息"

  },

  "po": {
    "number": "PO No.",
    "refreshRequest": "刷新申请",
    "downloadRequest": "下载申请"
  },
  "facilities": {
    "feedBedding": "动物及环境监测",
    "environmental": "仪器设备及报修",
    "corpse": "尸体处理记录",
    "veterinary": "动物护理-兽医",
    "instrument": "仪器设备管理",
    "personnel": "人员信息管理",
    "detection": "饮食饮水检测"
  },

  "orderAndFeed": {
    "newOrderApplication": "新提交动物订单申请",
    "ordersToBeReceived": "待接收动物订单",
    "totalOrdersMonth": "本月总订单数",
    "totalOrderAmount": "本月订单总金额",
    "experimenterInfo": "实验员信息",
    "raisingRoom": "饲养区域",
    "environment": "环境要求",
    "appComTime": "申请/完成时间",
    "group": "课题组",
    "groupName": "课题组名称",
    "mail": "邮箱",
    "phone": "手机号码",
    "requestNumber": "订购数量",
    "expectDeliveryDate": "预计送达日期",
    "inventoryStatus": "库存状态",
    "deliveryTime": "送货时间",
    "addPurchase": "加购",
    "feedingRequest": "饲养要求",
    "feedingFloor": "饲养楼层",
    "envRequirements": "环境要求",
    "raisingComment": "饲养备注",
    "orderComment": "订购备注",
    "quarantineExpenses": "隔离检疫费 (元) ",
    "quarantineInfo": "隔离检疫信息",
    "animalDeliveryate": "动物送达日期必须提前一周，且需在送达日期当天下午3点前送达，否则概不接收",
    "purifyInfo": "净化信息",
    "allele": "杂/纯合子",
    "weeksOfAge": "周龄",
    "SelfPurchasedAniInfo": "自行购买动物进入信息",
    "animalOrigin": "动物来源",
    "purificationExpenses": "净化费",
    "experimenter": "实验员",
    "researchGroup": "课题组",
    "completionTime": "完成时间",
    "animalGrade": "动物级别",
    "takeItAway": "是否带走",
    "PIApproved": "PI审核通过",
    "PINotApproved": "PI审核不通过",
    "ordering": "订购下单",
    "orderReceive": "订单接收",
    "completeBP": "完成生物净化",
    "completeQuarantine": "完成隔离检疫",
    "complete": "已完成",
    "Age/Weight": "年龄/重量",
    "orderLimit": "订购上限/日",
    "orderableStatus": "可订购状态",
    "associatedOrderNumber": "关联订单编号",
    "requestType": "申请类型",
    "status": "状态",
    "amount": "订单金额",
    "animalOrderingInfo": "动物订购信息",
    "animalReceptionInfo": "动物接收信息",
    "genotype": "基因型",
    "selectIACUC": "请选择IACUC编号",
    "animalNumber": "动物数量",
    "quarantineNumber": "检疫数量"
  },

  "costsAndSettlement": {
    "bankAccount": "账户",
    "exportDetails": "导出明细",
    "exportGeneralTable": "导出总表",
    "animalRequest": "动物申请",
    "bPurification": "生物净化",
    "quarantine": "隔离检疫",
    "animalRaising": "动物饲养",
    "instrumentation": "仪器使用",
    "materialRequisition": "物料领用",
    "manualDeduction": "手动扣费",
    "totalCost": "合计费用",
    "settlementCost": "结算费用",
    "total": "总计",
    "balance": "余额",
    "HeadResearchGroup": "课题组负责人",
    "start-stopDate": "起止日期",
    "settlementNumber": "结算编号",
    "SettlementMethod": "结算方式",
    "appUpDate": "申请/更新日期",
    "rechargeAmount": "充值金额",
    "refundAmount": "退款金额",
    "rechargeRefundMethod": "充值/退款方式",
    "provideCeOrNot": "是否提供凭证"
  },

  "form": {
    "Species": "物种",
    "Strain": "品系",
    "Weight": "体重",
    "Age": "年龄",
    "Weight/Age": "体重/年龄",
    "Gender": "性别",
    "Class": "级别",
    "Vendor": "供应商",
    "Comments": "备注"
  },

  announcement: {
    name: '公告',
    add: '新增公告',
    title: '公告标题',
    content: '公告内容',
    notificationObjects: '通知对象',
    releaseTime: '发布时间',
    createdBy: '发布人',
    status: '状态',
    releaseMsg: '发布时是否推送系统消息',
    wholeMembers: '全体成员',
    tenement: '租户',
    category: '分类',
    draft: '草稿',
    release: '已发布',
    removed: '已下架',
    remove: '下架'
  },

  changeLog: {
    animalRequest: '动物申请',
    changeTime: '修改时间',
    changeBy: '修改人',
    changeFieldName: '修改字段名称',
    previousValue: '旧值',
    newValue: '新值',
    changeType: '修改类型',
    delete: '删除',
    update: '更新',
    insert: '新增',
    reorder: '排序',
    visibleMode: '默认',
    hiddenMode: '显示隐藏'
  },

  payment: {
    costType: '消费类型',
    foreignKey: '业务ID',
    operator: '操作人',
    paymentTime: '付款时间',
    finalAmount: '付款金额',
    preAmount: '付款前金额',
    postAmount: '付款后金额'
  },

  fileManagement: {
    TransferToFileManagement: '转存至实验文件夹'
  },

  "cardboard": "纸箱",
  "plastic": "塑料",
  "metalMesh": "金属",
  "others": "其他",
  "y": "是",
  "n": "否",
  "normal": "正常",
  "brokenContainer": "破损",
  "foundDead": "发现死亡",
  "abnormalityVisualChecking": "表观异常"
}
